import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

// Ecran de chargement pendant la soumission du formulaire
const LoadingScreen = () => (
  <div className="fixed top-0 left-0 z-50 flex items-center justify-center w-full h-full bg-black/50">
    <div className="w-32 h-32 border-t-2 border-b-2 border-gray-500 rounded-full animate-spin" />
  </div>
);

export function LoginHome({ onLogin }) {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState("");
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const navigate = useNavigate();

  // Gestion des changements dans les champs du formulaire
  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  // Toggle de la visibilité du mot de passe
  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prev) => !prev);
  };

  // Soumission du formulaire de connexion
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage("");

    try {
      const response = await axios.post(" https://search.mg.formafusion.io/api/login", formData);

      const { status, user, profilCfp, type_customer, message: resMessage } = response.data;

      if (status === 200) {
        // Assurer que type_customer est dans l'objet user
        const userWithType = {
          ...user,
          type_customer: type_customer || user.type_customer || 1
        };

        // Sauvegarder en sessionStorage
        localStorage.setItem("user", JSON.stringify(response.data.user));
        localStorage.setItem("authToken", response.data.token);
        localStorage.setItem("type_customer", response.data.type_customer);
        localStorage.setItem("idCustomer", response.data.id_customer);

        // Appeler onLogin AVANT la navigation
        onLogin?.(userWithType, profilCfp || userWithType);

        // Attendre un court délai pour que le state se mette à jour
        setTimeout(() => {
          navigate('/');
        }, 100);

      } else {
        setMessage(resMessage || "Identifiants incorrects");
      }

    } catch (error) {
      const errMsg = error.response?.data?.message || "Erreur de connexion au serveur.";
      setMessage(errMsg);
      console.error("Login error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {isSubmitting && <LoadingScreen />}

      <div className="container h-full px-4 pt-8 mx-auto">
        <div className="flex flex-col items-center justify-center h-full px-6 lg:flex-row lg:mx-80">
          <div className="xl:w-3/4 w-full bg-[#f1f1f4] rounded-xl px-10 pb-10 mb-20">
            <div className="flex flex-col items-center mb-6">
              <img src="build/image/Logo_mark.svg" alt="Logo" className="mt-6 w-28 h-28" />
              <h1 className="text-3xl mt-4 font-extrabold text-[#A462A4] text-center">
                Connectez-vous
              </h1>
            </div>

            <form onSubmit={handleSubmit} className="p-6 bg-white shadow-lg rounded-xl">
              <div className="mb-4">
                <label htmlFor="email" className="text-gray-700">Adresse email</label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="votre-adresse@gmail.com"
                  required
                  className="w-full h-10 pl-2 text-gray-700 bg-white border border-gray-200 rounded-md outline-none input input-bordered hover:border-purple-300 focus:border-purple-300 focus:ring-2 focus:ring-purple-100"
                />
              </div>

              <div className="mb-4">
                <label htmlFor="password" className="text-gray-700">Mot de passe</label>
                <div className="relative">
                  <input
                    id="password"
                    name="password"
                    type={isPasswordVisible ? "text" : "password"}
                    value={formData.password}
                    onChange={handleChange}
                    required
                    className="w-full h-10 pl-2 text-gray-700 bg-white border border-gray-200 rounded-md outline-none password hover:border-purple-300 focus:border-purple-300 focus:ring-2 focus:ring-purple-100"
                  />
                  <i
                    onClick={togglePasswordVisibility}
                    className={`fa-solid ${isPasswordVisible ? "fa-eye-slash" : "fa-eye"} absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 cursor-pointer`}
                    aria-label="Afficher le mot de passe"
                  />
                </div>
                {message && <p className="mt-2 text-sm text-red-500">{message}</p>}
              </div>

              <div className="grid mt-6 place-items-center">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`w-full px-4 py-2 text-white rounded-xl bg-[#a462a4] ${isSubmitting ? "opacity-50 cursor-not-allowed" : "hover:bg-[#A462A4]/90"}`}
                >
                  {isSubmitting ? "Connexion en cours..." : "Connexion"}
                </button>
              </div>
            </form>

            <p className="pt-4 text-lg text-[#a462a4] underline font-bold hover:text-[#9d4ed4] hover:underline-offset-4 text-center">
              <Link to="/register">Pas encore de compte ? Inscrivez-vous</Link>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
